export default __webpack_public_path__ + "static/media/Icon3_On.9e987e6b.png";